import React, { Fragment,useEffect, useState, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import localization from 'assets/localization/localization';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import CardSection from 'components/sales/cardSection/cardSection';
import DivLayout from 'components/sales/divLayout/divLayout';
import { Button } from 'react-bootstrap';
import Config from "services/config/config";
import axios from "services/interceptor/Interceptor";
import { toast } from 'react-toastify';

const ClientMapping = ({
  history,
  match,
  getClientAddressForContractMapping,
  clientAddressData
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [addressData, setAddressData] = useState([]);
  const [clientName, setClientName] = useState(null);
  const [clientId, setClientId] = useState(null);
  const [isValid, setIsValid] = useState(false);
  const [mappingComplete, setMappingCompete] = useState(0);
  const [isDisabled, setIsDisabled] = useState(false);
  const [clientPoc, setClientPoc] = useState('');
  
  console.log('PAGE:: CLIENT CONTRACT MAPPING');
  //console.log('mapping ' + mappingComplete);

  useEffect(() => {
     if(match.params.comm_id != null || match.params.comm_id != undefined) {
        (async () => {
          await getClientAddressForContractMapping(match.params.comm_id);
        })();
     }
  },[match.params.comm_id]);

  useEffect(() => {
      if(clientAddressData) {
        setAddressData(clientAddressData?.data);
        setClientId(clientAddressData?.client_id);
        setClientName(clientAddressData?.client_poc);
        setIsValid(clientAddressData?.isValid);
        setMappingCompete(clientAddressData?.all_complete);
        setClientPoc(clientAddressData?.client_poc);
      }
  },[clientAddressData]);

  const handleMapping = (id,comm_id) => {
      if(id !== undefined && comm_id !== undefined) {
        if(window.confirm("Are you sure for this action?") == false) {
          return false;
        }
        (async () => {
          setIsDisabled(true);
          setIsLoading(true);
          const payload = {
             id: id,
             comm_id: parseInt(comm_id)
          }
          const url = `${Config.installation.mapClientAddressToContract}`;
          const { data } = await axios.post(url,payload);
          console.log(data)
          if(data && data?.response.data == true) {
            setIsLoading(false);
            toast.success('Updated Successfully.');
            setTimeout((function() {
              window.location.reload();
            }), 3000);
          } else {
            setIsLoading(false);
            if(data?.message){
              toast.error(data?.message);
            } else {
              toast.error('Something went wrong, please try again.');
            }
          }
          setIsLoading(false);
        })();
      } 
  }

  const handleMasterMapping = (id,comm_id) => {
    if(id !== undefined && comm_id !== undefined) {
      if(window.confirm("Are you sure for this action?") == false) {
        return false;
      }
      (async () => {
        setIsDisabled(true);
        setIsLoading(true);
        const payload = {
           id: id,
           comm_id: parseInt(comm_id)
        }
        const url = `${Config.installation.mapMasterClientAddressToContract}`;
        const { data } = await axios.post(url,payload);
        if(data && data?.response.data == true) {
          setIsLoading(false);
          toast.success('Updated Successfully.');
          setTimeout((function() {
            window.location.reload();
          }), 3000);
        } else {
          setIsLoading(false);
          if(data?.message){
            toast.error(data?.message);
          } else {
            toast.error('Something went wrong, please try again.');
          }
        }
        setIsLoading(false);
      })();
    } 
}

  const headerBtns = () => {
    return (
    <Fragment>
      {clientId && match.params.lead_id ?
        
          
            <a
                
                href={`${baseUrl}/add-client-location/1/${match.params.lead_id}/${clientId}/${match.params.comm_id}`}
                className="filter-hamburger show-btn btn btn-transparent"
            >
                {' '}
                {localization.addClientAddress}
            </a>
        
            
        :
            null
      }
        
    </Fragment> 
    )
  };

  return (
    <Layout
      title={localization.clinetAddresses}
      isLoading={isLoading}
      Buttons={headerBtns}
      isGoback
    >
    <strong>Client Name : {clientName}</strong>
    <br/>
    {addressData && addressData?.length > 0 && addressData.map((value,index) => {
      return (
        <CardSection title={localization.address + ' ' + (index+1)} key={index} 
        clsName={value?.address_type === "MASTER" ? 'mh2' : ''} 
        status = {value?.address_type}
        >
            <div className="details-listing">
            <DivLayout
                  heading={localization.registeredName}
                  data={value.registered_name ?
                        value.registered_name
                        :
                        clientName
                        }
              />
              <DivLayout
                  heading={localization.addressLine1}
                  data={value.address_line_1}
              />
              <DivLayout
                  heading={localization.addressLine2}
                  data={value.address_line_2}
              />
              <DivLayout
                  heading={localization.city}
                  data={value.city_name}
              />
              <DivLayout
                  heading={localization.state}
                  data={value.state_name}
              />
              <DivLayout
                  heading={localization.pinCode}
                  data={value.pincode}
              />
              <DivLayout
                  heading={localization.clientGST}
                  data={value.client_gst}
              />
              {/* <DivLayout
                  heading={localization.clinetPoc}
                  data={value.detail}
              /> */}
              <DivLayout
                  heading={localization.addressCreatedBy}
                  data={value.address_created_by}
              />
              {value?.address_type == 'MASTER' ? (
                null
              )
              :value?.address_type == 'OTHER' ? (
                <>
                  <div className='col-md-12' style={{'padding':'15px 0px 15px 0px'}}>
                    <button className='btn btn-theme btn-green' disabled={true}>Mapped</button>
                  </div>
                  {
                    (!value.lead_id && !value.comm_id) && 
                    <div className='col-md-12' style={{'padding':'15px 0px 15px 0px'}}>
                      <button onClick={()=> handleMasterMapping(value.id,match.params.comm_id)} className='btn btn-theme'>Map Master Client Address</button>
                    </div>
                  }
                </>
              )
              :
                <>
                  <div className='col-md-12' style={{'padding':'15px 0px 15px 0px'}}>
                    <button onClick={()=> handleMapping(value.id,match.params.comm_id)} className='btn btn-theme'>Map Client Address to contract</button>
                  </div>
                </>
                
              }
              {/* {value.is_activated  && value.is_activated == 1 ? (
                <div className='col-md-12' style={{'padding':'15px 0px 15px 0px'}}>
                <button className='btn btn-primary btn-green-v2' disabled={true}>Mapped</button>
              </div>
              ):<div className='col-md-12' style={{'padding':'15px 0px 15px 0px'}}>
                <button onClick={()=> handleMapping(value.id,match.params.comm_id)} className='btn btn-primary btn-red'>Map Client Address</button>
                </div>} */}
            </div>
        </CardSection>        
      )
    })}
    </Layout>
  );
};

export default ClientMapping;
